export const LogoMark = ({ className = "h-8 w-8", stroke = "currentColor" }) => (
  <svg viewBox="0 0 40 40" className={className} fill="none" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="20" cy="6.5" r="3" strokeWidth="1.6" />
    <path d="M20 9.5V36" strokeWidth="1.6" />
    <path d="M14 15h12" strokeWidth="1.6" />
    <path d="M8 24.5a12 12 0 0 0 24 0" strokeWidth="1.6" />
    <path d="M5.2 27.3 8 24.5l2.8 2.8M29.2 27.3l2.8-2.8 2.8 2.8" strokeWidth="1.6" />
    <circle cx="20" cy="36" r="1.4" fill={stroke} stroke="none" />
  </svg>
);

export const Logo = ({ light = false, testId = "logo" }) => (
  <span data-testid={testId} className={`flex items-center gap-2.5 ${light ? "text-white" : "text-[var(--ink)]"}`}>
    <LogoMark className="h-8 w-8 text-[var(--brass)]" />
    <span className="leading-none" dir="ltr">
      <span className="block font-display text-[22px] tracking-[0.18em]">OGEN</span>
      <span className="block text-[9px] uppercase tracking-[0.42em] opacity-70 mt-0.5">Hospitality</span>
    </span>
  </span>
);
